(() => {
  if (customElements.get('nostea-gallery')) return;
  class NosteaGallery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const track = this.querySelector('.nostea-gallery__track');
      const slides = Array.from(this.querySelectorAll('.nostea-gallery__slide'));
      const thumbnails = Array.from(this.querySelectorAll('[data-gallery-thumbnail]'));
      const previous = this.querySelector('[data-gallery-previous]');
      const next = this.querySelector('[data-gallery-next]');
      const count = this.querySelector('[data-gallery-index]');
      if (!track || slides.length < 2) return;
      let index = 0;
      const render = () => {
        count.textContent = String(index + 1);
        previous.disabled = index === 0;
        next.disabled = index === slides.length - 1;
        thumbnails.forEach((thumbnail, i) => {
          if (i === index) thumbnail.setAttribute('aria-current', 'true');
          else thumbnail.removeAttribute('aria-current');
        });
      };
      const update = () => {
        const trackLeft = track.getBoundingClientRect().left;
        index = slides.reduce((best, slide, i) => Math.abs(slide.getBoundingClientRect().left - trackLeft) < Math.abs(slides[best].getBoundingClientRect().left - trackLeft) ? i : best, 0);
        render();
      };
      const go = (target) => {
        target = Math.max(0, Math.min(slides.length - 1, target));
        index = target;
        render();
        const offset = slides[target].getBoundingClientRect().left - track.getBoundingClientRect().left;
        track.scrollBy({ left: offset, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      previous.hidden = false;
      next.hidden = false;
      previous.addEventListener('click', () => go(index - 1));
      next.addEventListener('click', () => go(index + 1));
      thumbnails.forEach((thumbnail, i) => thumbnail.addEventListener('click', (event) => { event.preventDefault(); go(i); }));
      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          go(index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      let scheduled = false;
      track.addEventListener('scroll', () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => { update(); scheduled = false; });
      }, { passive: true });
      track.addEventListener('scrollend', update);
      update();
    }
  }
  customElements.define('nostea-gallery', NosteaGallery);
})();
